// Module
var code = "<style>@font-face{font-family:babylon;src:url('{{babylonFont}}') format('woff');font-weight:400;font-style:normal}.icon{font-family:babylon}</style> {{#if fillScreen}} <style>body,html{width:100%;height:100%;margin:0;padding:0}</style> {{/if}} <fill-container></fill-container>";
// Exports
module.exports = code;